module.exports = __webpack_public_path__ + "static/media/learntech-logo.0f8e60b3.png";